export default {"src":"/_next/static/media/catalogMapPlaceholderMobile.3e822f84.svg","height":480,"width":375,"blurWidth":0,"blurHeight":0};